(ns hai.notes.eql
  "The EQL shapes notes travel in, shared by every note-editing surface.")

(def note-eql
  "The note shape the expanded editor works with — the shape any host should
   resolve for the note it hands to the editor body."
  [:note/uuid :note/text :note/updated-at
   ;; Needed by `sharing/can-edit?` so the Sharing dialog's permission cells
   ;; render as editable dropdowns (not read-only text) for admins, and by
   ;; `sharing/owner?`, which alone unlocks Delete.
   :user.entity/permissions
   :user.entity/owner?
   {:note/activities [:activity/uuid :activity/url]}
   ;; A tag carries its own permissions: `note/upsert` refuses to detach a tag
   ;; the requester isn't an admin of, so the chip must know whether to offer
   ;; a ✕ rather than let the save be rejected.
   {:note/tags [:group/uuid :group/display-name :user.entity/permissions]}
   {:note/contacts [:contact/uuid :contact/full-name :contact/organisation?]}
   {:note/notes [:note/uuid :note/text]}
   {:note/tasks [:task/uuid :task/title]}
   {:entity/shared-with
    [:entity/scope
     :user/uuid
     :user/email
     :user/full-name]}])
